import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/UserContext";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";

export const ProtectedRoute = () => {
  const { isAuth, isLoading } = useUser();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuth) {
    console.log("User is not authenticated, redirecting to login");

    return <Navigate to={"/login"} replace />;
  }

  return <Outlet />;
};
